import api from "../axios";
import {
  type Balance,
  type AutoTopUpInfo,
  type EnableAutoTopUpRequest,
  type CreateBalanceTopUp,
  type CreateBalanceTopUpResult,
  type TopUpInfo,
  type BonusTiersResponse,
} from "../types";

export class ApiBalance {
  getBalance(sellerId: string) {
    return api.get<Balance>(`/balances/${sellerId}`);
  }

  getBonusTiers() {
    return api.get<BonusTiersResponse>("/balances/bonus-tiers");
  }

  getAutoTopUpInfo(supplierId: string) {
    return api.get<AutoTopUpInfo>(
      `/balances/auto-top-up?supplier_id=${supplierId}`,
    );
  }

  disableAutoTopUp(autoTopUpId: string) {
    return api.post<void>(`/balances/auto-top-up/${autoTopUpId}/disable`);
  }

  enableAutoTopUp(autoTopUpId: string, data: EnableAutoTopUpRequest) {
    return api.post<void>(`/balances/auto-top-up/${autoTopUpId}/enable`, data);
  }

  topUpBalance(data: CreateBalanceTopUp) {
    return api.post<CreateBalanceTopUpResult>("/balances/top-up", data);
  }

  getTopUpInfo(topUpId: string) {
    return api.get<TopUpInfo>(`/balances/top-up/${topUpId}`);
  }
}
